<template>
	<div>
		<v-container>
			<reg-type-card
				v-model="job"
				:color="resourceStatus ? resourceStatus.color : ''"
				:resourceName="resourceName"
				:environmentName="environmentName"
				:qtdProducao="qtdProducao"
				:resourceWithSameJob="resourceWithSameJob"
				:regTypeDescription="resourceStatus ? resourceStatus.status : ''"
				:jobId="jobId"
				:jobDescription="jobDescription"
				:resourceId="resourceId"
				@confirmJob="getJobStage($event)"
				@clearJob="clearJob(true)"
				@change-resource="changeResource"
				:resourceStatus="resourceStatus"
			></reg-type-card>

			<alert-box
				class="pt-5"
				v-model="alert.alerts"
				:type="alert.type"
			></alert-box>
		</v-container>

		<reg-type-list
			v-model="regTypes"
			@click="clickRegType($event)"
			:resourceMenuLoading="resourceMenuLoading"
		></reg-type-list>

		<regTypeAutoFormDialog
			v-if="itemSelected"
			:jobStage="jobStage"
			:variables="variables"
			ref="autoFormDialog"
			v-model="itemSelected"
			@confirm="sendReg"
			@close="cancelRegistry"
			@date-retroactive="($event) => (dateRetroactive = $event)"
		></regTypeAutoFormDialog>

		<notification ref="notification"></notification>
	</div>
</template>

<script>
	import regTypeCard from "@/components/registries/regTypeCard";
	import regTypeList from "@/components/registries/regTypeList";
	import regTypeAutoFormDialog from "@/components/forms/regTypes/regTypeAutoFormDialog";
	import regTypeService from "@/services/regTypeService.js";
	import reportService from "@/services/reportService.js";
	import jobStageService from "@/services/jobStageService.js";
	import regService from "@/services/regService.js";
	import resourceService from "@/services/resourceService.js";
	import printerService from "@/services/printerService.js";
	import jobService from "@/services/jobService";
	import authService from "@/services/authService.js";
	import moment from "moment";

	export default {
		components: {
			regTypeAutoFormDialog,
			regTypeCard,
			regTypeList,
		},
		data() {
			return {
				//  job: "",
				environmentId: this.$route.query.environmentId,
				resourceId: this.$route.query.resourceId,
				resourceName: this.$route.query.resourceName,
				environmentName: this.$route.query.environmentName,
				job: this.$route.query.jobCode,
				jobDescription: "",
				qtdProducao: null,
				resourceWithSameJob: [],
				jobId: this.$route.query.jobId,
				jobStageId: this.$route.query.jobStageId,
				regTypeId: this.$route.query.regTypeId,
				resource: null,
				resourcePrinter: null,
				resourceStatus: {},
				regType: null,
				jobStage: null,
				regTypes: [],
				alert: {
					alerts: [],
					type: "error",
				},
				itemSelected: null,
				resourceMenuLoading: false,
				dateRetroactive: null,
				confirmed: false,
				producao: null,
				variables: []
			};
		},
		watch: {
			async regTypeId(value) {
				if (!value) return;
				await this.getRegTypeById(value);
			},
		},

		methods: {
			async changeResource(resource) {
				let confirm = await this.$confirm();
				if (!confirm) return;
				this.resourceMenuLoading = true;
				let res = await jobStageService.updateOrder(
					this.jobStage.id,
					null,
					resource.id,
					null,
					true
				);

				if (!res.success) {
					this.alert.alerts = res.data;
					return;
				}
				await this.clearJob();

				this.resourceMenuLoading = false;
			},
			cancelRegistry() {
				this.itemSelected = null;
			},
			async clearJob() {
				this.job = "";
				this.jobId = null;
				this.jobStage = null;
				this.jobCode = "";
				this.jobStageId = null;
				this.color = null;

				//2.00.6
				this.navigateRegistryRegType(this.job);
				await this.getRegTypes();
				await this.getRegTypeById(this.regTypeId);
				await this.getResourceStatus();
			},

			async clickRegType(regType) {
				this.itemSelected = regType;
				this.regType = regType;
				let parametros = await authService.getUserParams();
				var scheduleControl = null;
				parametros.claims.map((r) => {
					if (r.type.includes("Schedules")) {
						var obj = JSON.parse(r.value);
						scheduleControl = obj;
					}
				});

				if (scheduleControl) {
					const weekday = [
						"Sunday",
						"Monday",
						"Tuesday",
						"Wednesday",
						"Thursday",
						"Friday",
						"Saturday",
					];

					const d = new Date();
					let day = weekday[d.getDay()];

					//console.log("dia", day);

					var schedule = scheduleControl.find((x) => x.Day == day);

					//console.log("schedule", schedule);

					if (!schedule.StartTime && !schedule.EndTime) {
						await this.clickRegTypeCheck(regType);
					} else {
						const hStart = schedule.StartTime.split(":");
						const hEnd = schedule.EndTime.split(":");
						const dateStart = new Date();
						const dateEnd = new Date();
						const dateAtual = new Date();
						dateStart.setHours(hStart[0], hStart[1], 0);
						dateEnd.setHours(hEnd[0], hEnd[1], 0);

						let horaStart = 24 - parseInt(hStart[0]);
						let horaEnd = 24 - parseInt(hEnd[0]);

						//console.log("dataAtual", dateAtual);

						if (horaEnd >= horaStart) {
							//console.log("new day");
							let newDateEnd = moment()
								.add(1, "d")
								.toDate();

							if (dateAtual >= dateStart && dateAtual <= newDateEnd) {
								await this.clickRegTypeCheck(regType);
							} else {
								this.alert.alerts = ["Fora do horário de produção"];
								return;
							}
						} else {
							if (dateAtual >= dateStart && dateAtual <= dateEnd) {
								await this.clickRegTypeCheck(regType);
								return;
							} else {
								this.alert.alerts = ["Fora do horário de produção"];
								return;
							}
						}
					}
				} else {
					await this.clickRegTypeCheck(regType);
				}
			},

			async clickRegTypeCheck(regType) {
				this.itemSelected = regType;
				this.regType = regType;
				await this.$forceUpdate();
				if (regType.regTypeFields.length > 0 || regType.allowRetroactive) {
					this.$refs.autoFormDialog.open();
				} else {
					let con = await this.$confirm(`${regType.description}`);
					if (!con) {
						this.cancelRegistry();
						return;
					}
					await this.$forceUpdate();
					await this.sendReg([]);
					if (regType.description.includes("Finalizar")) {
						await this.clearJob();
					}
				}
			},


			// 12/08/2022
			async updateCardReg() {
				this.jobId = this.jobStage ? this.jobStage.jobId : null;
				await this.getResourceStatus();
				this.$forceUpdate();
				await this.closeAutoFormDialog();
			},

			async closeAutoFormDialog() {
				if (this.regType?.continuous === true) {
					//this.$refs.notification.show([this.$t("done")], "success");
					//this.$refs.notification.show([this.$t("done")], "success");
					await this.clickRegTypeCheck(this.regType);
					return;
				}
				if (!this.$refs.autoFormDialog) return;
				// if (this.$refs.autoFormDialog.isOpen())
				// 	this.$refs.autoFormDialog.open();

			},

			async sendReg(regFields) {
				this.$loading();
				this.$refs.autoFormDialog.loadingConfirm();
				let reg = {
					confirmed: this.confirmed,
					resourceId: this.resourceId,
					regTypeId: this.itemSelected.id,
					jobStageId: this.jobStage ? this.jobStage.id : null,
					regFields: regFields,
					retroactive: this.dateRetroactive != null,
					date: this.dateRetroactive,
				};

				let res = await regService.insertOrUpdate(reg);

				let resTriggerConfirm = await this.sendTriggerConfirm(res, reg);
				if (resTriggerConfirm != null) res = resTriggerConfirm;

				this.$refs.autoFormDialog.loadingConfirm();

				if (!res.success) {
					if (
						(this.regType.regTypeFields &&
							this.regType.regTypeFields.length > 0) ||
						this.regType.allowRetroactive
					)
						res.data.forEach((err) => this.$refs.autoFormDialog.addAlert(err));
					else this.alert.alerts = res.data;
					this.$loading(false);
				} else {
					if (res.messages && res.messages.length > 0) {
						this.$refs.notification.show(res.messages, "success");
					}

					if (this.regType.reportId) {
						let printRes = await reportService.getByRegId(res.data.id);

						console.log(JSON.stringify(printRes.data));

						const printerPath = this.resourcePrinter
							? this.resourcePrinter.path
							: printRes.data.printerPath;
						const printAgentPath = this.resourcePrinter
							? this.resourcePrinter.printAgentPath
							: printRes.data.printAgentPath;

						if (printRes.success) {
							let resPrintTexts = await printerService.sendPrintTexts(
								printRes.data.prints,
								printerPath,
								printAgentPath
							);

							if (!resPrintTexts.success) {
								this.alert.alerts = resPrintTexts.data;
							}
						} else {
							this.$loading(false);
						}
					}

					this.updateCardReg(this.itemSelected);
					this.$loading(false);
					this.itemSelected = null;
				}
			},

			clearNotifications() {
				this.alert.alerts = [];
			},

			async sendTriggerConfirm(result, reg) {
				let isTriggerConfirm =
					this.regType.trigger && this.regType.trigger.confirm;

				if (isTriggerConfirm && !result.success) {
					let msg = result.data[0];
					let confirmRes = await this.$confirm(null, msg);
					if (confirmRes) {
						reg.confirmed = true;
						result = await regService.insertOrUpdate(reg);
						return result;
					} else {
						result.data = ["abort confirm"];
					}
				}
			},

			async getRegTypes() {
				let stageRequired = this.jobStage != null;
				//let stageTypeId = this.jobStage ? this.jobStage.stageTypeId : null;
				let res = await regTypeService.getByResourceIdAndStageRequired(
					this.resourceId,
					stageRequired
				);

				if (res.success) {
					let rt = res.data.sort((a, b) => {
						return a.description > b.description
							? +1
							: a.description < b.description
							? -1
							: 0;
					});
					this.regTypes = rt;
				} else {
					this.alert.alerts = res.data;
				}
			},
			async getResource() {
				const res = await resourceService.getById(this.resourceId);
				this.resourceWithSameJob = [];

				if(res.data.Variables.length > 0){
					this.variables = res.data.Variables
				}

				for (let i = 0; i < res.data.resourceRestIds.length; i++) {
					let response = await jobStageService.getByJobCodeAndResource(
						this.job,
						res.data.resourceRestIds[i]
					);

					if (response?.data?.jobStageItemProds != null) {
						this.resourceWithSameJob.push(response.data.jobStageItemProds);
					}
				}

				if (res.success) this.resource = res.data;
				else this.alert.alerts = res.data;

				if (this.resource.printerId) {
					const printerRes = await printerService.getById(
						this.resource.printerId
					);
					if (printerRes.success) this.resourcePrinter = printerRes.data;
				}
			},

			async getResourceStatus() {
				await this.getResource();
				let res = await resourceService.getStatusByResourceId(this.resourceId);
				let jobStage = await jobStageService.getById(res?.data?.jobStageId);
				//this.producao = producao;

				//console.log("ESTAGIO?", producao);

				if (res.success) this.resourceStatus = res.data;
				else this.alert.alerts = res.data;


				if(jobStage?.status == "Finalizado " || jobStage?.status == "Finalizado"){
					this.errorNotification(["Job Finalizado"]);
					this.jobStage = null;
					this.jobStageId = null;
					await this.getRegTypes();
					return;
				}
			},

			//2.00.6
			navigateRegistryRegType(job) {
				let currentQuery = this.$route.query;
				//let resourceStatus = this.resourceStatus;
				this.$router.replace({
					query: {
						environmentId: currentQuery.environmentId,
						environmentName: currentQuery.environmentName,
						resourceId: currentQuery.resourceId,
						resourceName: currentQuery.resourceName,
						color: "",
						regTypeId: "",
						jobCode: job,
						jobStageType: "",
					},
				}).catch(()=>{});
				this.$forceUpdate();
			},

			// Executa quando o @confirmJob é chamado
			async getJobStage(jobCode, mounted) {
				await this.getResourceStatus();
				this.clearNotifications();
				//console.log("jobcode:", jobCode, mounted);
				let res = await jobStageService.getByJobCodeAndResource(
					jobCode,
					this.resourceId
				);

				if (!res.data) {
					return;
				}

				let jobData = await jobService.getById(res.data.jobId);

				// if(jobData.data.status == "Finalizado " || jobData.data.status == "Finalizado"){
				// 	this.errorNotification(["Job Finalizado"]);
				// 	this.jobStage = null;
				// 	this.jobStageId = null;
				// 	await this.getRegTypes();
				// 	return;
				// }
				this.jobDescription = jobData.data.description;

				if (res.success) {
					if (res.data == null && !mounted) {
						this.errorNotification(["Job Stage not exist on Resource"]);
						this.jobStage = null;
						this.jobStageId = null;
						await this.getRegTypes();
						return;
					}

					this.qtdProducao = res.data.jobStageItemProds;

					if (res.data.status == "Finalizado") {
						this.alert.alerts = ["Job Finalizado"];
					}

					//2.00.6
					this.navigateRegistryRegType(jobData.data.code);
					this.jobStage = res.data;
					await this.getRegTypes();
					this.updateCardReg();
					this.$forceUpdate();
				}
			},
			async getRegTypeById(id) {
				if (!id) return;
				let res = await regTypeService.getById(id);
				if (res.success) {
					this.regType = res.data;
					this.updateCardReg(this.regType);
				}
			},
			errorNotification(list) {
				list.forEach((e) => this.alert.alerts.push(e));
			},
		},
		async mounted() {
			this.$loading();
			await this.getRegTypes();
			await this.getRegTypeById(this.regTypeId);
			await this.getResourceStatus();
			let job = this.$route.query.jobCode;
			if (job) await this.getJobStage(job, true);
			this.$loading(false);
		},
	};
</script>
